<template>
  <div>
    <div
      class="header fix"
      :style="{ marginTop: isPhone && headerNum === 0 ? '64px' : '' }"
    >
      <div class="header-width" :style="{ width: isPhone ? '100%' : '' }">
        <ul class="header-ul">
          <a href="https://www.yangtuoedu.com" class="logo">
            <img
              src="/static/img/2020-12-28/pic_logo_IELTS.png"
              alt="羊驼雅思logo"
            />
          </a>
          <template v-if="!isPhone">
            <li
              v-for="(item, index) in headerList"
              :key="index"
              :class="[{ active: index === headerNum }, { isHidden: loginWeb }]"
            >
              <a
                v-if="item.inside"
                :href="item.url"
                @click.prevent="isPhoneGoTest(item.url, index, item.text)"
                :style="{ color: index === headerNum ? '#1376f8' : '' }"
                >{{ item.text }}</a
              >
              <a
                v-scroll-to="{
                  el: '#school',
                  container: 'body',
                  duration: 500,
                  easing: 'linear',
                  offset: -50,
                  force: true,
                  cancelable: true,
                  x: false,
                  y: true
                }"
                style="font-weight:bold;"
                v-if="!item.inside"
                target="_blank"
                >{{ item.text }}</a
              >
            </li>
          </template>
        </ul>
        <div class="header-right">
          <ul class="header-right-ul header-ul">
            <li
              class="more-link"
              @mouseenter="showMore = true"
              @mouseleave="showMore = false"
            >
              <a href="javascript:;" :class="{ isHidden: loginWeb }"
                >更多服务</a
              >
              <transition name="fade">
                <div
                  v-if="showMore && !isPhone"
                  class="dropdown-menu dropdown-menu-lg dropdown-menu-arrow more-services-panel py-0 hidden-xs-List"
                >
                  <ul class="dropDown-menu">
                    <li
                      @mouseenter="moreHover(0)"
                      :class="moreIndex == 0 ? 'active' : ''"
                    >
                      <a
                        href="https://yangtuoedu.com"
                        target="_blank"
                        onclick=" _czc.push([\'_trackEvent\', \'羊驼教育\', \'羊驼教育\']);"
                        >羊驼教育</a
                      >
                      <div class="more-services-right">
                        <img
                          src="/static/img/more-service/pic_PTE_alpaca.png"
                          alt=""
                        /><a
                          href="https://yangtuoedu.com"
                          target="_blank"
                          onclick=" _czc.push([\'_trackEvent\', \'羊驼教育\', \'羊驼教育\']);"
                        ></a>
                      </div>
                    </li>
                    <li
                      @mouseenter="moreHover(1)"
                      :class="moreIndex == 1 ? 'active' : ''"
                    >
                      <a
                        href="https://www.ytaxx.com"
                        target="_blank"
                        onclick=" _czc.push([\'_trackEvent\', \'羊驼PTE\', \'羊驼PTE\']);"
                        >羊驼PTE</a
                      >
                      <div class="more-services-right">
                        <img
                          src="/static/img/more-service/pic_PTE_PTE.png?yt-v=20230717"
                          alt=""
                        />
                        <a
                          href="https://www.ytaxx.com"
                          target="_blank"
                          onclick=" _czc.push([\'_trackEvent\', \'羊驼PTE\', \'羊驼PTE\']);"
                        ></a>
                      </div>
                    </li>
                    <li
                      @mouseenter="moreHover(2)"
                      :class="moreIndex == 2 ? 'active' : ''"
                    >
                      <a
                        href="https://www.ytaxx.com/det"
                        target="_blank"
                        onclick=" _czc.push([\'_trackEvent\', \'羊驼多邻国\', \'羊驼多邻国\']);"
                        >羊驼多邻国</a
                      >
                      <div class="more-services-right">
                        <img
                          src="/static/img/more-service/pic_PTE_DET.png"
                          alt=""
                        /><a
                          href="https://www.ytaxx.com/det"
                          target="_blank"
                          onclick=" _czc.push([\'_trackEvent\', \'羊驼多邻国\', \'羊驼多邻国\']);"
                        ></a>
                      </div>
                    </li>
                    <li
                      @mouseenter="moreHover(3)"
                      :class="moreIndex == 3 ? 'active' : ''"
                    >
                      <a
                        href="https://yangtuoedu.com/static/en/index.html"
                        target="_blank"
                        onclick=" _czc.push([\'_trackEvent\', \'羊驼英语\', \'羊驼英语\']);"
                        >羊驼英语</a
                      >
                      <div class="more-services-right">
                        <img
                          src="/static/img/more-service/pic_PTE_Eng.png"
                          alt=""
                        /><a
                          href="https://yangtuoedu.com/static/en/index.html"
                          target="_blank"
                          onclick=" _czc.push([\'_trackEvent\', \'羊驼英语\', \'羊驼英语\']);"
                        ></a>
                      </div>
                    </li>
                    <li
                      @mouseenter="moreHover(4)"
                      :class="moreIndex == 4 ? 'active' : ''"
                    >
                      <a
                        href="http://ccl.ytaxx.com"
                        target="_blank"
                        onclick=" _czc.push([\'_trackEvent\', \'羊驼CCL\', \'羊驼CCL\']);"
                        >羊驼CCL</a
                      >
                      <div class="more-services-right">
                        <img
                          src="/static/img/more-service/pic_PTE_CCL.png"
                          alt=""
                        /><a
                          href="http://ccl.ytaxx.com"
                          target="_blank"
                          onclick=" _czc.push([\'_trackEvent\', \'羊驼CCL\', \'羊驼CCL\']);"
                        ></a>
                      </div>
                    </li>
                    <li
                      @mouseenter="moreHover(5)"
                      :class="moreIndex == 5 ? 'active' : ''"
                    >
                      <a
                        href="https://yangtuoedu.com/jp"
                        target="_blank"
                        onclick=" _czc.push([\'_trackEvent\', \'羊驼日语\', \'羊驼日语\']);"
                        >羊驼日语</a
                      >
                      <div class="more-services-right">
                        <img
                          src="/static/img/more-service/pic_PTE_JP.png"
                          alt=""
                        /><a
                          href="https://yangtuoedu.com/jp"
                          target="_blank"
                          onclick=" _czc.push([\'_trackEvent\', \'羊驼日语\', \'羊驼日语\']);"
                        ></a>
                      </div>
                    </li>
                    <li
                      @mouseenter="moreHover(6)"
                      :class="moreIndex == 6 ? 'active' : ''"
                    >
                      <a
                        href="https://www.yangtuoedu.com/kr"
                        target="_blank"
                        onclick=" _czc.push([\'_trackEvent\', \'羊驼韩语\', \'羊驼韩语\']);"
                        >羊驼韩语</a
                      >
                      <div class="more-services-right">
                        <img
                          src="/static/img/more-service/pic_PTE_KRO.png?yt-v=20230717"
                          alt=""
                        />
                        <a
                          href="https://www.yangtuoedu.com/kr"
                          target="_blank"
                          onclick=" _czc.push([\'_trackEvent\', \'羊驼韩语\', \'羊驼韩语\']);"
                        ></a>
                      </div>
                    </li>
                    <li
                      @mouseenter="moreHover(7)"
                      :class="moreIndex == 7 ? 'active' : ''"
                    >
                      <a
                        href="http://ymlx.ytaxx.com"
                        target="_blank"
                        onclick=" _czc.push([\'_trackEvent\', \'移民留学互助平台\', \'移民留学互助平台\']);"
                        >移民留学互助平台</a
                      >
                      <div class="more-services-right">
                        <img
                          src="/static/img/more-service/pic_PTE_IS.png"
                          alt=""
                        /><a
                          href="http://ymlx.ytaxx.com"
                          target="_blank"
                          onclick=" _czc.push([\'_trackEvent\', \'移民留学互助平台\', \'移民留学互助平台\']);"
                        ></a>
                      </div>
                    </li>
                  </ul>
                </div>
              </transition>
            </li>
            <li
              @mouseenter="showApp(true, 'isShowgroup', '交流群')"
              @mouseleave="showApp(false, 'isShowgroup', '交流群')"
            >
              <a href="javascript:">交流群</a>
              <transition name="fade">
                <div
                  class="header-right-silde"
                  v-if="isShowgroup"
                  style="width: 382px;height: 178px;right: -10px"
                >
                  <img src="./../../static/img/m_hover_com.png" alt="" />
                </div>
              </transition>
            </li>
            <li
              @mouseenter="showApp(true, 'isShowApp', '羊驼雅思APP')"
              @mouseleave="showApp(false, 'isShowApp', '羊驼雅思APP')"
              v-if="!isPhone"
            >
              <a href="javascript:">羊驼雅思APP</a>
              <transition name="fade">
                <div class="header-right-silde" v-if="isShowApp">
                  <img
                    src="/static/img/pic_appdownload.png"
                    alt=""
                    class="show-img"
                  />
                  <div class="add">
                    <h3>当季口语题库</h3>
                    <p>
                      高频考题实时更新，英式发音外教答案示范，AI评测跟读评分
                    </p>
                    <h3>剑桥系列</h3>
                    <p>历年真题汇总，高分解析，试卷/题型、话题分类</p>
                    <h3>写作视频解析/写作观点库</h3>
                    <p>
                      历年考试真题讲师视频讲解，思维指导，专业词汇学习，观点库提供主体段论证思维
                    </p>
                    <h3 class="word">词汇精练</h3>
                    <p>雅思备考都在用的智能背词APP</p>
                  </div>
                </div>
              </transition>
            </li>
            <!-- <li>
              <a href="https://www.ytaxx.com/" target="_blank" :class="{isHidden:loginWeb}" style="color: #1376f8">羊驼PTE</a>
            </li>
            <li v-if="!isPhone">
              <a href="http://ymlx.ytaxx.com" target="_blank" :class="{isHidden:loginWeb}">移民留学互助平台</a>
            </li>
            <li v-if="isPhone">
              <a href="http://ymlx.ytaxx.com" target="_blank" :class="{isHidden:loginWeb}">移民留学</a>
            </li> -->
          </ul>
          <div class="header-login" :class="{ isHidden: loginWeb }">
            <Dropdown trigger="click" @on-click="exitLogin">
              <div class="login-content" @click="isShowLogin" v-if="!isPhone">
                <img :src="loginImgCom" />
                <p>{{ loginNameCom }}</p>
              </div>
              <div
                class="app-show-header"
                style="display: flex;align-items: center;"
                v-if="isPhone"
              >
                <img
                  :src="loginAppImgCom"
                  style="width: 30px;margin-right: 6px"
                  @click="isShowLogin"
                />
                <img
                  src="/static/img/icon_menu_more.png"
                  style="width:14px;height: 14px;margin-left: 10px;"
                  @click.stop="isShowMenu = !isShowMenu"
                />
              </div>
              <DropdownMenu slot="list" v-if="isLogin">
                <DropdownItem disabled name="0">学习记录</DropdownItem>
                <DropdownItem name="1">切换账号</DropdownItem>
                <DropdownItem name="2">退出登录</DropdownItem>
              </DropdownMenu>
            </Dropdown>
          </div>
        </div>
      </div>
      <Modal
        v-model="showLogin"
        footer-hide
        scrollable
        title="登录"
        width="360px"
        :styles="{ top: '300px' }"
      >
        <div v-if="!isWechat">
          <div
            style="width: 90%;display: flex;margin: 0 auto;justify-content: space-between;align-items: center;"
          >
            <Select v-model="selectNum" style="width:70px">
              <Option
                v-for="item in numList"
                :value="item.value"
                :key="item.value"
                >{{ item.label }}</Option
              >
            </Select>
            <p>+</p>
            <Input
              v-model="phone"
              placeholder="请输入手机号"
              style="width: 200px"
              type="text"
              :maxlength="11"
            />
          </div>
          <div
            style="width: 90%;display: flex;margin: 0 auto;justify-content: space-between;align-items: center;margin-top:20px;"
          >
            <Input
              v-model="code"
              search
              prefix="ios-contact"
              @on-search="getCode()"
              :enter-button="timeCom"
              style="width: 100%"
              :maxlength="6"
              placeholder="请输入验证码"
              type="text"
            />
          </div>
          <div
            style="width: 90%;margin: 0 auto;margin-top: 20px;text-align: end;color: #999;font-size: 14px;"
          >
            直接输入手机号即可注册
          </div>
          <div style="width: 90%;margin: 0 auto;margin-top: 20px;">
            <Button type="primary" long @click="login()">登录</Button>
          </div>
          <!-- <div style="
            display: flex;
            cursor:pointer;
            align-items: center;
            width: 34%;
            margin: 0 auto;
            margin-top: 40px;
            justify-content: space-between;
            margin-bottom: 10px;" @click="wechatLogin">
                <p>微信扫码登录</p>
              <img style="width: 25px;height: 21px;" src="./../../static/img/icon_wechat.png" alt="">
            </div> -->
        </div>

        <div v-if="isWechat">
          <div
            style="display: flex;justify-content: center;align-items: center;"
          >
            <img :src="wechatImg" alt="" style="height: 190px;width: 190px" />
          </div>
          <div
            style="display: flex;align-items: center;width: 40%;margin: 0 auto;margin-top: 20px;justify-content: space-between;margin-bottom: 10px;"
            @click="wechatLogin"
          >
            <img
              style="width: 25px;height: 21px;"
              src="./../../static/img/icon_wechat.png"
              alt=""
            />
            <p style="font-size: 16px;">微信扫码登录</p>
          </div>
          <div
            style="text-align: center;display: block;cursor:pointer;align-items: center;margin: 0 auto;margin-top: 20px;justify-content: space-between;margin-bottom: 10px;"
            @click="wechatLogin"
          >
            <p
              style="color: #4c97ff;font-size: 16px;"
              @click="isWechat = false"
            >
              手机验证登录 >
            </p>
          </div>
        </div>
      </Modal>
    </div>
    <transition name="slide-fade">
      <div
        class="header-menu-ul"
        v-if="isShowMenu"
        :style="{ top: headerNum === 0 ? '128px' : '64px' }"
      >
        <ul>
          <li><a href="/">首页</a></li>
          <li @click="modal()">机考</li>
          <li @click="modal()">机经</li>
          <li @click="modal()">练习/精听</li>
          <li><a href="/Curriculum">课程</a></li>
          <!-- <li><a href="/news/">资讯</a></li> -->
        </ul>
      </div>
    </transition>
    <transition name="slide-fade">
      <div
        class="header-menu-ul"
        v-if="showMore && isPhone"
        :style="{ top: headerNum === 0 ? '128px' : '64px' }"
      >
        <ul>
          <a
            href="https://yangtuoedu.com"
            target="_blank"
            onclick=" _czc.push([\'_trackEvent\', \'羊驼教育\', \'羊驼教育\']);"
          >
            <li>羊驼教育</li>
          </a>
          <a
            href="https://www.ytaxx.com"
            target="_blank"
            onclick=" _czc.push([\'_trackEvent\', \'羊驼PTE\', \'羊驼PTE\']);"
          >
            <li>羊驼PTE</li>
          </a>

          <a
            href="https://www.ytaxx.com/det"
            target="_blank"
            onclick=" _czc.push([\'_trackEvent\', \'羊驼多邻国\', \'羊驼多邻国\']);"
          >
            <li>羊驼多邻国</li>
          </a>
          <a
            href="https://yangtuoedu.com/static/en/index.html"
            target="_blank"
            onclick=" _czc.push([\'_trackEvent\', \'羊驼英语\', \'羊驼英语\']);"
          >
            <li>羊驼英语</li>
          </a>
          <a
            href="http://ccl.ytaxx.com"
            target="_blank"
            onclick=" _czc.push([\'_trackEvent\', \'羊驼CCL\', \'羊驼CCL\']);"
          >
            <li>羊驼CCL</li>
          </a>
          <a
            href="https://yangtuoedu.com/jp"
            target="_blank"
            onclick=" _czc.push([\'_trackEvent\', \'羊驼日语\', \'羊驼日语\']);"
          >
            <li>羊驼日语</li>
          </a>
          <a
            href="https://www.yangtuoedu.com/kr"
            target="_blank"
            onclick=" _czc.push([\'_trackEvent\', \'羊驼韩语\', \'羊驼韩语\']);"
          >
            <li>羊驼韩语</li>
          </a>
          <a
            href="http://ymlx.ytaxx.com"
            target="_blank"
            onclick=" _czc.push([\'_trackEvent\', \'移民留学互助平台\', \'移民留学互助平台\']);"
          >
            <li>移民留学互助平台</li>
          </a>
        </ul>
      </div>
    </transition>
  </div>
</template>

<script>
// import { scrollAnimation } from './../../static/js/scroll';
import ajax from "./../api/ajax";
import { addCookie, getCookie, delCookie } from "./../api/cookie";
export default {
  inject: ["reload"],
  name: "Header",
  data() {
    return {
      isLogin: false,
      url: "https://winielts.com", //用户登录URL
      showLogin: false,
      isPhone: false,
      active: 0, //顶部选中状态
      isShowApp: false,
      phone: "", //手机号
      code: "", //验证码
      isShowgroup: false, //是否展示交流群
      numList: [
        { value: 86, label: "+86" },
        { value: 886, label: "+886" },
        { value: 44, label: "+44" },
        { value: 62, label: "+62" },
        { value: 61, label: "+61" },
        { value: 60, label: "+60" },
        { value: 64, label: "+64" },
        { value: 65, label: "+65" }
      ],
      selectNum: 86,
      headerList: [
        {
          url: "/",
          text: "首页",
          inside: true
        },
        {
          url: "/exerciselist",
          text: "机考",
          inside: true
        },
        {
          url: "/scripture",
          text: "机经",
          inside: true
        },
        {
          url: "/listenlist",
          text: "练习/精听",
          inside: true
        },
        {
          url: "/Curriculum",
          text: "课程",
          inside: true
        }
        // {
        //   url: "/news/",
        //   text: "资讯",
        //   inside: true,
        // }
      ],
      isSend: false, //是否已经输入验证码
      isSendTime: 0, //输入验证码剩余时间
      isWechat: false,
      wechatImg: "",
      time: "",
      user: "",
      showMore: false,
      isShowMenu: false,
      moreIndex: 0
    };
  },
  mounted() {
    if (document.body.clientWidth <= 750) {
      this.isPhone = true;
    }
    document.body.addEventListener("touchend", function() {}); //解决:hover、before、after伪类在ios移动端需要二次点击的问题
    this.getUser();
    if (getCookie("token")) {
      this.isLogin = true;
    }
    this.getNumList();
  },
  props: {
    headerNum: Number,
    loginWeb: Boolean //是否是登录页面
  },
  computed: {
    timeCom() {
      if (!this.isSend) {
        return "获取验证码";
      } else {
        return `剩余${this.isSendTime}秒`;
      }
    },
    loginNameCom() {
      if (getCookie("token") && this.user) {
        return this.user.nickName;
      } else {
        return "登录/注册";
      }
    },
    loginImgCom() {
      if (getCookie("token") && this.user) {
        return this.user.icon;
      } else {
        return "/static/img/icon_login.png";
      }
    },
    loginAppImgCom() {
      if (getCookie("token") && this.user) {
        return this.user.icon;
      } else {
        return "/static/img/nav_icon_login.png";
      }
    }
  },
  methods: {
    exitLogin(val) {
      //退出登录
      if (val === "1") {
        //切换账号
        this.showLogin = true;
      } else if (val === "2") {
        //退出登录
        this.isLogin = false;
        delCookie("token");
        this.reload();
      }
    },
    isShowLogin() {
      if (this.isLogin) {
        return;
      } else {
        this.showLogin = true;
      }
    },
    getNumList() {
      ajax(this.url + "/api/message/countryList", {}, "POST").then(res => {
        if (res.code === 0) {
          this.numList = res.data.map(item => {
            return {
              value: item.phonecode,
              label: "+" + item.phonecode
            };
          });
        }
      });
    },
    async login() {
      //手机号登录
      if (this.selectNum === 86) {
        let reg = /^[1]([3-9])[0-9]{9}$/;
        if (!reg.test(this.phone)) {
          this.$Message.warning("请输入正确的手机号");
          return;
        }
      } else {
        let reg2 = /^[0-9]*$/;
        if (!reg2.test(this.phone)) {
          this.$Message.warning("请输入正确的手机号");
          return;
        }
      }

      let reg2 = /^\d{6}$/;
      if (!reg2.test(this.code)) {
        this.$Message.warning("请输入正确的六位数验证码");
        return;
      }
      const data = await ajax(
        this.url + "/api/auth/loginPhone",
        { phone: this.phone, code: this.code, phonecode: this.selectNum },
        "POST",
        { sourceBazaar: "web", clientType: "web" }
      );
      if (data.code === 0) {
        addCookie("token", data.data.token, 30);
        this.reload();
      } else {
        this.$Message.warning(data.msg);
      }
    },
    async getUser() {
      let token = getCookie("token");
      if (token) {
        let data = await ajax(this.url + "/api/auth/getUser", {}, "GET", {
          token: token
        });
        this.user = data.data;
      }
    },
    async wechatLogin() {
      //微信登录
      const data = await ajax(this.url + "/api/auth/callBack", {
        clientType: "pcweb"
      });
      if (data.code === 0) {
        this.wechatImg = data.data.url;
        let t = setInterval(() => {
          this.wxLoginInterval(data.data.sceneId, t);
        }, 1000);
      } else {
        this.$Message.info(data.msg);
      }
      this.isWechat = true;
      console.log(data);
    },
    async wxLoginInterval(sceneId, t) {
      const data = await ajax(
        this.url + "/api/auth/verifySceneId",
        { sceneId: sceneId },
        "GET",
        { serviceVersion: 3 }
      );
      if (data.code === 0) {
        let token = data.data.token;
        addCookie("token", token, 30);
        clearInterval(t);
        this.reload();
      } else if (data.code === 10008) {
        this.$router.push({ name: "login", params: { userCode: data.msg } });
        clearInterval(t);
      }
    },

    async getCode() {
      //手机验证码
      if (!this.isSend) {
        if (this.selectNum === 86) {
          let reg = /^[1]([3-9])[0-9]{9}$/;
          if (!reg.test(this.phone)) {
            this.$Message.warning("请输入正确的手机号");
            return;
          }
        } else {
          let reg2 = /^[0-9]*$/;
          if (!reg2.test(this.phone)) {
            this.$Message.warning("请输入正确的手机号");
            return;
          }
        }
        this.isSendTime = 60;
        const data = await ajax(
          this.url + "/api/message/sendSms",
          { phone: this.phone, phonecode: this.selectNum },
          "POST"
        );
        if (data.code === 0) {
          this.$Message.success("发送成功！");
          this.time = setInterval(() => {
            this.isSendTime--;
            if (this.isSendTime === 0) {
              this.isSend = false;
              clearInterval(this.time);
              this.isSendTime = 60;
            }
          }, 1000);
          this.isSend = true;
        } else {
          this.$Message.warning(data.msg);
        }
      } else {
        this.$Message.warning(`请等待${this.isSendTime}秒！`);
      }
    },
    modal() {
      this.$Modal.warning({
        title: "提示",
        content: "移动端暂不支持该功能，请登录PC端体验"
      });
    },
    isPhoneGoTest(url, i, text) {
      if (text === "资讯") {
        window.location.href = "https://www.winielts.com/news/";
        return;
      }
      console.log(url, i, text);
      // console.log(this.headerNum);
      _czc.push(["_trackEvent", "头部", text]);
      if (this.isPhone && i >= 1 && i <= 2) {
        this.$Modal.warning({
          title: "提示",
          content: "移动端暂不支持该功能，请登录PC端体验"
        });
      } else {
        this.$router.push({ path: url });
      }
    },
    showApp(flag, type, name) {
      this[type] = flag; //当参数作为对象的时候不能使用.语法
      _czc.push(["_trackEvent", "头部", name]);
    },
    changeItem(index) {
      this.active = index;
      console.log(this.active);
    },

    // goScroll(event){
    //   let top = 0;
    //   this.isPhone ? top = 300 : top = 680
    //   const currentY = document.documentElement.scrollTop || document.body.scrollTop
    //   scrollAnimation(currentY, top)
    // },
    moreHover(index) {
      this.moreIndex = index;
    }
  }
};
</script>
<style>
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}

input[type="number"] {
  -moz-appearance: textfield;
}

.slide-fade-enter-active {
  transition: all 0.3s ease;
}

.slide-fade-leave-active {
  transition: all 0.3s ease;
}

.slide-fade-enter,
.slide-fade-leave-to

/* .slide-fade-leave-active for below version 2.1.8 */
 {
  transform: translateY(-10px);
  opacity: 0;
}
</style>
<style scoped lang="stylus">
  .more-link{
    width:auto!important;
    >a{
      color: #fff!important;
      background: rgb(19, 118, 248);
      height: 30px!important;
      padding: 0 10px;
      border-radius: 15px;
      display: flex;
      align-items: center;
    }
  }
  .more-link:after{
    content:'';
    width:35px;
    height:15px;
    background:url('/static/img/icon_NEW.png')no-repeat;
    position:absolute;
    top:-10px;
    right:-15px;
  }
  .dropdown-menu.more-services-panel {
    position:absolute
    width: 500px;
    height: 340px;
    background-color: #ffffff;
    border-radius: 6px;
    top:140%;
    left: -150px;
    box-shadow: 0 0.5rem 1rem rgba(0,0,0,.175);s
    &:before{
      position: absolute;
      z-index: -5;
      bottom: 100%;
      left: 60px;
      display: block;
      width: 16px;
      height: 16px;
      content: '';
      transform: rotate(-45deg) translateY(1rem);
      border-radius: .2rem;
      background: #fff;
      box-shadow: none;
    }
    ul {
      position: relative;
      li {
        display: flex;
        justify-content: space-between;
        height: 40px;
        a {
          font-family:"思源黑体";
          font-size: 16px;
          font-weight: normal;
          font-stretch: normal;
          line-height: 42px;
          letter-spacing: 0px;
          color: #333333;
          background: #fff;
          margin: 8px 0 0 15px;
          >span{
            width: 60px;
            height: 18px;
            background-color: #ff8817;
            border-radius: 4px;
            font-family:"思源黑体";
            font-size: 12px;
            font-weight: normal;
            font-stretch: normal;
            line-height: 18px;
            letter-spacing: 0px;
            color: #ffffff;
            margin-left: 10px;
            display: inline-block;
            text-align: center;
          }
        }
        .more-services-right {
          position: absolute;
          height: 340px;
          display: none;
          top: 0;
          left: 180px;
          overflow:hidden;
          img{
            width:auto;
            display:block;
            border-top-right-radius:6PX;
            border-bottom-right-radius:6PX;
          }
        }
      }
      li.active a{
        color: #735ce6;
      }
      li .more-services-right a{
        position: absolute;
        bottom: 20px;
        right: 20px;
        width: 108px;
        height: 34px;
      }
    li:nth-child(1) .more-services-right a{
      background: url('/static/img/more-service/Buttom_ALPACA.png') no-repeat;
    }
    li:nth-child(2) .more-services-right a{
      background: url('/static/img/more-service/Buttom_PTE.png') no-repeat;
    }
    li:nth-child(3) .more-services-right a{
      background: url('/static/img/more-service/Buttom_DET.png') no-repeat;
    }
    li:nth-child(4) .more-services-right a{
      background: url('/static/img/more-service/Buttom_ENG.png') no-repeat;
    }
    li:nth-child(5) .more-services-right a{
      background: url('/static/img/more-service/Buttom_CCL.png') no-repeat;
    }
    li:nth-child(6) .more-services-right a{
      background: url('/static/img/more-service/Buttom_JP.png') no-repeat;
    }
    li:nth-child(7) .more-services-right a{
      background: url('/static/img/more-service/Buttom_KRO.png') no-repeat;
    }
    li:nth-child(8) .more-services-right a{
      background: url('/static/img/more-service/Buttom_IS.png') no-repeat;
    }
      li.active .more-services-right, li:hover .more-services-right{
          display:block;
      }
    }
  }

  .isHidden
    visibility hidden
  .fix
    position: fixed
    top:0
    width 100%
    z-index 10
  .header-menu-ul
    position fixed
    width 100%
    background #fff
    box-shadow: -1.5px 0px 5px 0px rgba(31, 82, 173, 0.24);
    z-index: 9;
    ul
      width 90%
      margin 0 auto
      li
        height 32px
        border-bottom: 1px solid #f2f2f2
        color #333
        font-size: 10px;
        line-height 32px
        a
          display block
          color inherit
      li:last-child
        border none
  .header-width
    display: flex
    align-items: center
    width 74%
    margin 0 auto
    justify-content space-between
    height 100%
  .header-login
    /*margin-left:70px*/
    width: 130px;
    height: 40px;
    background-color: #1376f8;
    border-radius: 20px;
    .login-content
      display: flex
      align-items: center
      height: 40px;
      width: 130px;
      justify-content: space-evenly
      cursor pointer
      img
        height:28px
        width:28px
        border-radius 50%
      p
        color: #fff
        font-size:14px
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        text-align: left;
        width 60px
  .fade-enter-active, .fade-leave-active {
    transition: opacity .5s
  }
  .fade-enter, .fade-leave-active {
    opacity: 0
  }
  .header-right-silde  .add {
      position:absolute
      left:55px
      top:58px
      width:360px
  }

  .header-right-silde  img
    width:800px

   .header-right-silde  .add h3:nth-child(-n+5) {
      font-weight:bold
      color:#4657d8
      font-size:16px
   }
   .header-right-silde  .add .word{
    color: #ff8817;
    font-size:16px
    font-weight:bold
   }
 .header-right-silde  .add p {
   color:#333
   font-size:12px
   margin:5px 0
 }
  .header-right-silde
    width: 843px;
    height: 408px;
    position absolute
    top: 85px
    display flex
    align-items center
    justify-content space-around
    z-index:999
    right -110px
    .silde-lef
      height 100%
      img
        height 232px
        width 180px
.header
  height: 64px;
  box-shadow: 0 1px 1px rgba(0,0,0,0.1);
  background: #fff;
  /*display: flex*/
  /*align-items: center*/
  .logo
    /*margin-left: 14%;*/
    /*margin-left 14%*/
    img
      width: 160px;
  .header-ul
    height 100%
    display: flex
    align-items: center
    &>li.active::before
      position absolute
      bottom 0px
      content ''
      height: 2px
      width: 16px
      background-color: #53a4f4;
      a
        font-weight bold
        font-size 14px
    &>li:hover::before
      position absolute
      bottom 0px
      content ''
      height: 2px
      width: 16px
      background-color: #53a4f4;
    &>li
      height 100%
      display: flex
      width: auto
      margin 0 20px
      align-items: center
      justify-content: center
      cursor pointer
      position: relative
      &>a
        color: #333
        font-size:14px
        height: 100%
        line-height 64px
        width: 100%
        text-align: center
        font-weight: bold

  .header-right{
  display: flex;
  align-items:center;
  // margin-left: 16%;
  position: relative;

}
.header-right-h1{
  padding-left: 6px
  font-size: 16px;
  color: #1979ff;
  cursor: pointer;
  /*font-weight: bold*/
}
.header-right-span{
  position: absolute;
  font-size: 8px;
  color: #fff;
  right: -28px;
  top: -12px;
  background-image linear-gradient(right, #ff689b,#ff2929);
  width: 40px;
  height: 16px;
  text-align: center
  line-height:16px
  border-radius: 8px;
}

@media only screen and (max-width: 1200px) and (min-width: 992px) {
  a,p{
    font-size 14px
  }
  .header-ul{
    margin-left:0;
  }
}
@media only screen and (max-width: 991px) and (min-width: 300px){
  .header-ul{
    margin-left:0;
  .active a{
    font-size 13px
  }
  .active::after{
    width 70px
  }
    li{
      width 70px
      a{
        font-size:14px
      }
    }
  }
}
@media only screen and (max-width: 750px) and (min-width: 300px){
  .logo img{
    width 130px
  }
  .header-width{
    width 100%
    justify-content: space-around
  }
  .header-right-ul{
    margin-left: 30px!important
  }
  .header-login{
    background: none;
    height auto;
    width auto;
  }
  .header-ul{
    margin-left:0;
    li{
      width 60px
      margin 0
      a{
        font-size:12px
      }
    }
  }
  .header-right{
    margin-left: 0
  }
}
@media only screen and (max-width: 1700px){
  .header-width{
    width 100%
  }

}
</style>



// WEBPACK FOOTER //
// src/components/Head.vue